import { Badge, Col, ListGroup, ListGroupItem, Row } from "reactstrap";

import CommonModal from "@components/ui-components/modal";
import { Conditions } from "./conditions";
import Flex from "@components/ui-components/flex";
import FormView from "@components/views/form-view";
import Goals from "../goals";
import InputField from "@components/fields/input-field";
import size from "lodash/size";
import { useTranslation } from "react-i18next";
import useUpsert from "./use-upsert";

// import Goals from "../goals";

const UpsertLifecycle = props => {
    const { modalConfig, handleModal } = props;

    const isEdit = !!size(modalConfig.row);
    const { onSubmit, methods, updateLoading, isDirty, handleGoals, goals, loading } =
        useUpsert({
            ...props,
            isEdit
        });
    const {
        control,
        formState: { errors },
        watch
    } = methods;

    const { t } = useTranslation();
    const content = [
        {
            leftChild: {
                title: "Lifecycle Metrics"
            },
            rightChild: (
                <ListGroup>
                    <Row>
                        <Col lg={4}>
                            <ListGroupItem className="justify-content-between" color="success">
                                {t("On Track Count")}
                                <Badge pill className="ms-3" color="success">
                                    {watch("onTrackCount")}
                                </Badge>
                            </ListGroupItem>
                        </Col>
                        <Col lg={4}>
                            <ListGroupItem className="justify-content-between" color="danger">
                                {t("On Stuck Count")}
                                <Badge pill className="ms-3" color="danger">
                                    {watch("stuckCount")}
                                </Badge>
                            </ListGroupItem>
                        </Col>
                        <Col lg={4}>
                            <ListGroupItem className="justify-content-between" color="warning">
                                {t("Behind Count")}
                                <Badge pill className="ms-3" color="warning">
                                    {watch("behindCount")}
                                </Badge>
                            </ListGroupItem>
                        </Col>
                    </Row>
                </ListGroup>
            ),
            omit: !isEdit
        },
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the life cycle which you wish to create"
            },
            rightChild: (
                <Row>
                    <InputField
                        id="name"
                        name="name"
                        label="Name"
                        required
                        control={control}
                        errors={errors}/>

                    <InputField
                        label="Description"
                        id="description"
                        type="textarea"
                        required
                        name="description"
                        control={control}
                        errors={errors}/>
                </Row>
            )
        },
        {
            leftChild: {
                title: "Life cycle start conditions"
            },
            rightChild: <Conditions name="life_cycle_start" type="start" methods={methods} />
        },
        {
            leftChild: {
                title: "Life cycle end conditions"
            },
            rightChild: <Conditions name="life_cycle_end" type="end" methods={methods} />
        },
        {
            leftChild: {
                title: "Set Lifecycle Days",
                desc : "Define the minimum and maximum day thresholds to track the status of companies."
            },
            rightChild: (
                <>
                    <InputField
                        label="Life Cycle should take number of day"
                        id="min_day"
                        name="min_day"
                        type="number"
                        required
                        control={control}
                        errors={errors}/>
                    <>
                        <p className="fw-bold">
                            {t(
                                "Companies that are up to {{min_day}} days in the lifecycle are",
                                {
                                    min_day: methods.watch("min_day") || "-"
                                }
                            )}
                            <span className="text-success">
                                &nbsp;{t("on track")}
                            </span>
                        </p>
                        <Flex align="center" className="fw-bold">
                            <p>{t("Companies that are more than and up to")}</p>
                            <InputField
                                id="max_day"
                                name="max_day"
                                type="number"
                                className="w-max"
                                showErrMsg={false}
                                control={control}
                                errors={errors}/>
                            <p>
                                {t("days in the lifecycle are")}{" "}
                                <span className="text-warning">
                                    &nbsp;{t("behind")}
                                </span>
                            </p>
                        </Flex>

                        <p className="fw-bold">
                            {t(
                                "Companies that are more than {{max_day}} days in the lifecycle are",
                                {
                                    max_day: methods.watch("max_day") || "-"
                                }
                            )}
                            <span className="text-danger">
                                &nbsp;{t("stuck")}
                            </span>
                        </p>
                    </>
                </>
            )
        },
        {
            leftChild: {
                title: "Set Lifecycle Goals"
            },
            rightChild: (
                <Goals
                    isEdit={isEdit}
                    modalConfig={modalConfig}
                    handleGoals={handleGoals}
                    goals={goals}/>
            )
        }
    ];

    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Life cycle`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="fullScreen"
            isDirty={isDirty}
            loading={loading}
            handleModal={handleModal}
            isOpen={modalConfig.isOpen}/>
    );
};

export default UpsertLifecycle;
